<template>
  <div id="property-detail-header">
    <div class="property-title">
      <div class="property-detail-name">
        <v-icon
          size="9"
          :color="getStatus"
          class="mr-2"
        >
          $faCircle
        </v-icon>
        <h1>{{ propertyDetails.name }}</h1>
        <div
          v-if="foundProperty && canEditProperty(propertyId) && canManageSelectedOrg"
          data-cy="edit-prop"
          class="edit-prop"
          @click="onEditProperty"
        >
          <font-awesome-icon icon="cog" />
          <span class="edit-prop-text">EDIT PROPERTY</span>
        </div>
      </div>
      <div class="property-id">
        ID: {{ propertyDetails.id }}
      </div>
    </div>
    <div class="details">
      <span class="detail">
        <v-icon
          color="#535353"
          size="16"
          class="detail__icon"
        >
          $faMapMarkerAlt
        </v-icon>
        <span class="detail__text">{{ propertyAddress }}</span>
      </span>
      <span
        v-if="propertyDetails.area"
        class="detail"
      >
        <v-icon
          color="#535353"
          size="16"
          class="detail__icon"
        >
          $faHomeLg
        </v-icon>
        <span class="detail__text">{{ propertyDetails.area }} SQ FT</span>
      </span>
      <span
        v-if="propertyDetails.maxOccupancy"
        class="detail"
      >
        <v-icon
          color="#535353"
          size="16"
          class="detail__icon"
        >
          $faUsers
        </v-icon>
        <span class="detail__text">{{ propertyDetails.maxOccupancy }} Max Occupancy</span>
      </span>
    </div>
    <div class="d-flex justify-space-between">
      <div class="tags">
        <v-chip
          v-for="tag in propertyDetails.tags"
          :key="tag.ID"
          class="tag"
          outlined
          small
        >
          {{ tag }}
        </v-chip>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import propertyStatusMixin from '@/helpers/property-status-mixin'

  export default {
    name: 'PropertyDetailHeader',
    mixins: [propertyStatusMixin],
    props: {
      propertyDetails: {
        type: Object,
      },
      eventData: {
        type: Object,
      },
    },
    data: () => ({
      statusColor: '#33A08E',
      address: '',
      foundProperty: false,
    }),
    computed: {
      ...mapGetters({
        canEditProperty: 'Permissions/canEditProperty',
        canManageSelectedOrg: 'Permissions/canManageSelectedOrg',
      }),
      propertyId () {
        return this.$route.params.id
      },
      propertyAddress () {
        const { street1, street2, city, region, postalcode } = this.propertyDetails

        if (street2) return `${street1}, ${street2}, ${city} ${region} ${postalcode}`
        return `${street1}, ${city} ${region} ${postalcode}`
      },
      getStatus () {
        const status = this.getPropertyStatus(
          this.propertyDetails.activityZoneCount,
          this.propertyDetails.activeEvents,
        )
        return status.color
      },
    },
    beforeUpdate () {
      if (this.propertyDetails) {
        this.foundProperty = true
      }
    },
    methods: {
      onEditProperty () {
        this.$router.push(`/properties/${this.propertyId}/edit`)
      },
    },
  }
</script>
<style lang="scss" scoped>
#property-detail-header {
  margin: 0 32px;
  .property-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-end;
  }
  .property-detail-name {
    display:flex;
    align-items:center;
    .status {
      font-size: 4.5rem;
      margin-right: 8px;
    }
    .edit-prop {
      display:flex;
      align-items:center;
      cursor: pointer;
      opacity:.4;
      margin-left: 8px;
      .svg-inline--fa {
        margin-right:4px;
        height:18px;
        width:19px;
      }
      .edit-prop-text {
        visibility: hidden;
      }
      &:hover {
        visibility:visible;
        opacity:1;
        color: $muted;
        .edit-prop-text {
          visibility: visible;
          font-size:.9rem;
        }
      }
    }
  }
  .property-id {
    color:#535353;
  }
  .details {
    margin: 4px 0 10px 0;
    display: flex;
    .detail {
      display: flex;
      align-items: center;
      line-height: 1.2rem;
      & + .detail {
        margin-left: 20px;
      }
      .detail__text {
        font-size: 16px;
        color: #2B394E;
      }
      .detail__icon + .detail__text {
        margin-left: 6px;
      }
    }
  }
  .tags {
    min-width:1rem;
    margin-bottom: 20px;
    span {
      margin:3px;
    }
  }
}
</style>
